import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  TrendBadge,
} from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { useTranslate } from '@tolgee/react';
import { UserX } from 'lucide-react';

interface LostInterestData {
  readonly id: string;
  readonly name: string;
  readonly email?: string;
  readonly reason?: string;
  readonly message?: string;
  readonly date: string;
}

interface Props {
  readonly value?: number;
  readonly changeInLastWeek?: number;
  readonly infoText?: string;
  readonly statistics?: any[];
  readonly data?: LostInterestData[];
}

export function CockpitLostInterestWidget(props: Props) {
  const { t } = useTranslate();

  return (
    <Card className="h-full flex flex-col">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl font-semibold">
            {t('cockpit_lost_interest_widget_title')}
          </CardTitle>
          <div className="flex items-center gap-2">
            <span className="text-sm font-medium text-muted-foreground">
              {props.value ?? 0} {t('cockpit_lost_interest_absagen')}
            </span>
            <div className="h-8 w-8 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
              <UserX className="h-4 w-4 text-red-600 dark:text-red-400" />
            </div>
          </div>
        </div>
        {props.infoText && (
          <p className="text-sm text-muted-foreground">
            {t(props.infoText as any) || props.infoText}
          </p>
        )}
      </CardHeader>
      <CardContent className="flex-1 pt-0">
        <div className="space-y-4 flex-1">
          {/* Trend Badge */}
          <div className="flex items-center gap-4">
            <span className="text-2xl font-bold tabular-nums text-gray-900 dark:text-gray-100">
              {props.value ?? 0}
            </span>
            {props.changeInLastWeek !== null &&
            props.changeInLastWeek !== undefined &&
            props.changeInLastWeek !== 0 ? (
              <TrendBadge value={props.changeInLastWeek} />
            ) : null}
          </div>

          {/* Summary Message */}
          {props.value && props.value > 0 ? (
            <div className="text-center py-6">
              <div className="inline-flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400">
                <UserX className="w-4 h-4" />
                <span>
                  {props.value === 1
                    ? t('cockpit_lost_interest_single_person')
                    : t('cockpit_lost_interest_multiple_persons', {
                        count: props.value,
                      })}
                </span>
              </div>
            </div>
          ) : (
            <EmptyState
              icon={<UserX className="w-6 h-6 text-gray-400" />}
              description={t('cockpit_lost_interest_no_interested')}
              compact
            />
          )}
        </div>
      </CardContent>
    </Card>
  );
}
